import { Suspense, useEffect, useState } from "react";
import FullscreenLoader from "./FullscreenLoader";

export default function WithDelay({
  children,
  minMs = 1500,          // set 1000–2000 as you want
  waitForFonts = true,   // optional: also wait for fonts to apply
}: {
  children: React.ReactNode;
  minMs?: number;
  waitForFonts?: boolean;
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const t = setTimeout(() => {
      const fontsReady =
        waitForFonts && "fonts" in document ? (document as any).fonts.ready : Promise.resolve();
    Promise.resolve(fontsReady).then(() => !cancelled && setReady(true));
    }, minMs);
    return () => { cancelled = true; clearTimeout(t); };
  }, [minMs, waitForFonts]);

  return (
    <Suspense fallback={<FullscreenLoader />}>
      {ready ? children : <FullscreenLoader />}
    </Suspense>
  );
}
